module.exports = __webpack_public_path__ + "images/external_images/svg/shapes/shape1.svg";